import React, { useEffect, useState } from 'react';
import {
    Input,
    InputGroup,
    Stack,
    Breadcrumb,
    Divider,
    Panel,
    Container,
    Table,
    SelectPicker,
    IconButton,
    CheckPicker,
    Button,
    Tooltip,
    Whisper,
    Checkbox,
    Notification,
    Drawer,
    Modal,
    FlexboxGrid,
    Col,
    Pagination
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';
import globalIP from '@/GlobelIP';
import QrcodeIcon from '@rsuite/icons/Qrcode';
import jsPDF from 'jspdf';
import QRCode from 'qrcode-generator';
import s1 from './template/QR1.jpg';
import s2 from './template/QR2.jpg';
import s3 from './template/QR3.jpg';
import s4 from './template/QR4.jpg';
import { Link } from 'react-router-dom';
import ugr from '@/UGRoute';



const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => (
    <Cell {...props} style={{ padding: 0 }}>
        <div style={{ lineHeight: '46px' }}>
            <Checkbox
                value={rowData[dataKey]}
                inline
                onChange={onChange}
                checked={checkedKeys.some(item => item === rowData[dataKey])}
            />
        </div>
    </Cell>
);

const { Column, HeaderCell, Cell } = Table;
const QRPrint = () => {
    const ip = globalIP
    const [fairname, setFairname] = useState([]);
    useEffect(() => {
        fetchDataFair();
    }, []);
    const fetchDataFair = async () => {
        const response = await fetch(`${ip}/api/fair-masters?populate=*&filters[fairstatus][$eq]=Active`);
        const json = await response.json()
        const processedData = json.data.map((item) => ({
            label: item.attributes.fairName,
            value: item.attributes.fairCode,
        }));
        setFairname(processedData);
    };

    const [productcode, setProductCode] = useState([]);
    useEffect(() => {
        if (fairname) {
            fetchDatap();
        }
    }, [fairname]);
    const fetchDatap = async () => {
        const response = await fetch(`${ip}/api/fair-product-masters?populate=*&pagination[page]=1&filters[faircode][$eq]=${fairname.map(item => item.value)}`);
        const json = await response.json()
        // Extract prdcd values from the API response
        const allData = [];
        for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
            const pageResponse = await fetch(`${ip}/api/fair-product-masters?populate=*&pagination[page]=${page}&filters[faircode][$eq]=${fairname.map(item => item.value)}`);
            const pageJson = await pageResponse.json();
            const prdcdArray = pageJson.data.map(item => item.attributes.prdcd);
            allData.push(...prdcdArray);
        }

        // Set prdcd values in the productcode state
        setProductCode(allData);
    };

    const [selectedCategoryCode, setSelectedCategoryCode] = useState([]);
    const [selectedProductType, setSelectedProductType] = useState([]);
    const [selectedAlias, setSelectedAlias] = useState([]);
    const [selectedpron, setSelectedPron] = useState([]);
    const [selectedpd, setSelectedProd] = useState([]);
    const [selectedmade, setSelectedMade] = useState([]);
    const [selectedsku, setSelectedSku] = useState([]);
    const [selectedColor, setSelectedColor] = useState([]);
    const [selectedFinish, setSelectedFinish] = useState([]);
    const [selectedhsn, setSelectedhsn] = useState([]);
    const [selectedBuyer, setSelectedBuyer] = useState([]);
    const [selectedSearch, setSelectedSearch] = useState([]);
    const [categorydata, setCategorydata] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        fetchDatacate();

    }, []);
    const fetchDatacate = async () => {
        if (isLoading) {
            return;
        }
        setIsLoading(true);
        try {
            const response = await fetch(`${ip}/api/mstcategories?&pagination[page]=1&filters[dis][$ne]=Discontinue`);
            const json = await response.json();
            const allData = [];
            for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
                const pageResponse = await fetch(`${ip}/api/mstcategories?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`);
                const pageJson = await pageResponse.json();
                const processedData = pageJson.data.map((item) => ({
                    label: item.attributes.CategoryName,
                    value: item.attributes.CategoryCode,
                }));
                allData.push(...processedData);
            }
            setCategorydata(allData);
            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching category data:', error);
        }
    };
    const [productypedata, setProductypedata] = useState([]);
    const [isLoadingpro, setIsLoadingpro] = useState(false);
    useEffect(() => {
        if (selectedCategoryCode) {
            fetchData2();
        }
    }, [selectedCategoryCode]);
    const fetchData2 = async () => {
        if (isLoadingpro) {
            return;
        }
        setIsLoadingpro(true);
        try {
            const productIdsQueryParam = selectedCategoryCode.map(id => `filters[Categorycode][$in][]=${id}`).join('&');
            // Construct the API URL by appending the query parameters
            const apiUrl = `${ip}/api/mstproducttypes?${productIdsQueryParam}&populate=*&pagination[page]=1`;
            const response = await fetch(apiUrl);
            const json = await response.json();
            const allData = [];
            for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
                const pageResponse = await fetch(`${ip}/api/mstproducttypes?${productIdsQueryParam}&populate=*&pagination[page]=${page}`);
                const pageJson = await pageResponse.json();
                const processedData = pageJson.data.map((item) => ({
                    label: item.attributes.ProductTypeName,
                    value: item.attributes.ProductTypeCode,
                }));
                allData.push(...processedData);
            }
            setProductypedata(allData);
            setIsLoadingpro(false);
        } catch (error) {
            console.error('Error fetching category data:', error);
        }
    };
    const [aliasdata, setAliasdata] = useState([]);
    const [isLoadingalias, setIsLoadinalias] = useState(false);
    useEffect(() => {
        fetchDataalias();
    }, []);
    const fetchDataalias = async () => {
        if (isLoadingalias) {
            return;
        }
        setIsLoadinalias(true);
        try {
            const response = await fetch(`${ip}/api/fetchs-aliascd`);
            const json = await response.json();
            const processedData = json.map(item => ({
                label: item.ProductId,
                value: item.ProductId,
            }));
            setAliasdata(processedData);
            setIsLoadinalias(false);
        } catch (error) {
            console.error('Error fetching category data:', error);
        }
    };
    const [proNamedata, setProdNamedata] = useState([]);
    const [isLoadingpron, setIsLoadingpron] = useState(false);
    useEffect(() => {
        fetchDatapron();

    }, []);
    const fetchDatapron = async () => {
        if (isLoadingpron) {
            return;
        }
        setIsLoadingpron(true);
        try {
            const response = await fetch(`${ip}/api/products-name`);
            const json = await response.json();
            const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords
            json.forEach((item) => {
                if (item.ProductName && !uniqueKeywords.has(item.ProductName)) {
                    uniqueKeywords.add(item.ProductName);
                }
            });
            const processedData = Array.from(uniqueKeywords).map((keyword) => ({
                label: keyword,
                value: keyword,
            }));
            setProdNamedata(processedData);
            setIsLoadingpron(false);
        } catch (error) {
            console.error('Error fetching category data:', error);
        }
    };
    const [skudata, setSkudata] = useState([]);
    const [isLoadingsku, setIsLoadinsku] = useState(false);
    useEffect(() => {
        fetchDatasku();

    }, []);
    const fetchDatasku = async () => {
        if (isLoadingsku) {
            return;
        }
        setIsLoadinsku(true);
        try {
            const response = await fetch(`${ip}/api/buyers-sku`);
            const json = await response.json();
            const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords
            json.forEach((item) => {
                if (item.BuyerSku && !uniqueKeywords.has(item.BuyerSku)) {
                    uniqueKeywords.add(item.BuyerSku);
                }
            });
            const processedData = Array.from(uniqueKeywords).map((keyword) => ({
                label: keyword,
                value: keyword,
            }));
            setSkudata(processedData);
            setIsLoadinsku(false);
        } catch (error) {
            console.error('Error fetching category data:', error);
        }
    };
    const [buyernamedata, setBuyerNamedata] = useState([]);
    const [isLoadingbu, setIsLoadingbu] = useState(false);
    useEffect(() => {
        fetchDatabuyerN();
    }, []);
    const fetchDatabuyerN = async () => {
        if (isLoadingbu) {
            return;
        }
        setIsLoadingbu(true);
        try {
            const response = await fetch(`${ip}/api/buyer-details?&pagination[page]=1`);
            const json = await response.json();
            const allData = [];
            for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
                const pageResponse = await fetch(`${ip}/api/buyer-details?&pagination[page]=${page}`);
                const pageJson = await pageResponse.json();
                const processedData = pageJson.data.map((item) => ({
                    label: item.attributes.buyernm,
                    value: item.attributes.buyernm,
                }));
                allData.push(...processedData);
            }
            setBuyerNamedata(allData);
            setIsLoadingbu(false);
        } catch (error) {
            console.error('Error fetching category data:', error);
        }
    };
    const [finishdata, setFinishdata] = useState([]);
    const [isLoadingfin, setIsLoadingfin] = useState(false);
    useEffect(() => {
        fetchData4();
    }, []);
    const fetchData4 = async () => {
        if (isLoadingfin) {
            return;
        }
        setIsLoadingfin(true);
        try {
            const response = await fetch(`${ip}/api/mstfinishes?&pagination[page]=1&filters[dis][$ne]=Discontinue`);
            const json = await response.json();
            const allData = [];
            for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
                const pageResponse = await fetch(`${ip}/api/mstfinishes?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`);
                const pageJson = await pageResponse.json();
                const processedData = pageJson.data.map((item) => ({
                    label: item.attributes.FinishName,
                    value: item.attributes.FinishCode,
                }));
                allData.push(...processedData);
            }
            setFinishdata(allData);
            setIsLoadingfin(false);
        } catch (error) {
            console.error('Error fetching category data:', error);
        }
    };
    const [colordata, setColordata] = useState([]);
    const [isLoadingcolor, setIsLoadingcolor] = useState(false);
    useEffect(() => {
        fetchData5();
    }, []);
    const fetchData5 = async () => {
        if (isLoadingcolor) {
            return;
        }
        setIsLoadingcolor(true);
        try {
            const response = await fetch(`${ip}/api/mstcolors?&pagination[page]=1&filters[dis][$ne]=Discontinue`);
            const json = await response.json();
            const allData = [];
            for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
                const pageResponse = await fetch(`${ip}/api/mstcolors?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`);
                const pageJson = await pageResponse.json();
                const processedData = pageJson.data.map((item) => ({
                    label: item.attributes.ColorName,
                    value: item.attributes.ColorCode,
                }));
                allData.push(...processedData);
            }
            setColordata(allData);
            setIsLoadingcolor(false);
        } catch (error) {
            console.error('Error fetching category data:', error);
        }
    };
    const [searchdata, setSearchdata] = useState([]);
    const [isLoadingse, setIsLoadingse] = useState(false);
    useEffect(() => {
        fetchDataSearch();

    }, []);
    const fetchDataSearch = async () => {
        if (isLoadingse) {
            return;
        }
        setIsLoadingse(true);
        try {
            const response = await fetch(`${ip}/api/searchs-keyword`);
            const json = await response.json();
            const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords

            json.forEach((item) => {
                if (item.SearchKeyword && !uniqueKeywords.has(item.SearchKeyword)) {
                    uniqueKeywords.add(item.SearchKeyword);
                }
            });

            const processedData = Array.from(uniqueKeywords).map((keyword) => ({
                label: keyword,
                value: keyword,
            }));
            setSearchdata(processedData);
            setIsLoadingse(false);
        } catch (error) {
            console.error('Error fetching category data:', error);
        }
    };
    const [proDdata, setProdDdata] = useState([]);
    const [isLoadingprod, setIsLoadingprod] = useState(false);
    useEffect(() => {
        fetchDataprod();
    }, []);
    const fetchDataprod = async () => {
        if (isLoadingprod) {
            return;
        }
        setIsLoadingprod(true);
        try {
            const response = await fetch(`${ip}/api/products-designer`);
            const json = await response.json();
            const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords
            json.forEach((item) => {
                if (item.ProductDesigner && !uniqueKeywords.has(item.ProductDesigner)) {
                    uniqueKeywords.add(item.ProductDesigner);
                }
            });
            const processedData = Array.from(uniqueKeywords).map((keyword) => ({
                label: keyword,
                value: keyword,
            }));
            setProdDdata(processedData);
            setIsLoadingprod(false);
        } catch (error) {
            console.error('Error fetching category data:', error);
        }
    };
    const [madedata, setMadedata] = useState([]);
    const [isLoadingmade, setIsLoadingmade] = useState(false);
    useEffect(() => {
        fetchDatamade();
    }, []);
    const fetchDatamade = async () => {
        if (isLoadingmade) {
            return;
        }
        setIsLoadingmade(true);
        try {
            const response = await fetch(`${ip}/api/mades-by`);
            const json = await response.json();
            const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords
            json.forEach((item) => {
                if (item.MadeBy && !uniqueKeywords.has(item.MadeBy)) {
                    uniqueKeywords.add(item.MadeBy);
                }
            });
            const processedData = Array.from(uniqueKeywords).map((keyword) => ({
                label: keyword,
                value: keyword,
            }));
            setMadedata(processedData);
            setIsLoadingmade(false);
        } catch (error) {
            console.error('Error fetching category data:', error);
        }
    };
    const [hsndata, setHsndata] = useState([]);
    const [isLoadinghsn, setIsLoadinghsn] = useState(false);
    useEffect(() => {
        fetchData6();
    }, []);
    const fetchData6 = async () => {
        if (isLoadinghsn) {
            return;
        }
        setIsLoadinghsn(true);
        try {
            const response = await fetch(`${ip}/api/msthscodes?&pagination[page]=1&filters[dis][$ne]=Discontinue`);
            const json = await response.json();
            const allData = [];
            for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
                const pageResponse = await fetch(`${ip}/api/msthscodes?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`);
                const pageJson = await pageResponse.json();
                const processedData = pageJson.data.map((item) => ({
                    label: item.attributes.hscode,
                    value: item.attributes.hscode,
                }));
                allData.push(...processedData);
            }
            setHsndata(allData);
            setIsLoadinghsn(false);
        } catch (error) {
            console.error('Error fetching category data:', error);
        }
    };
    const handleCategoryChange = (value) => {
        setCurrentPage(1);
        setSelectedCategoryCode(value);

    };
    const handleProductTypeChange = (value) => {
        setCurrentPage(1); // Reset page when color changes
        setSelectedProductType(value);
    };
    const handleAliasChange = (value) => {
        setCurrentPage(1); // Reset page when color changes
        setSelectedAlias(value);
    };
    const handleColorChange = (value) => {
        setCurrentPage(1); // Reset page when color changes
        setSelectedColor(value);

    };
    const handleFinishChange = (value) => {
        setCurrentPage(1); // Reset page when color changes
        setSelectedFinish(value);

    };
    const handleHSNChange = (value) => {
        setCurrentPage(1); // Reset page when color changes
        setSelectedhsn(value);

    };
    const handleBuyerChange = (value) => {
        setCurrentPage(1); // Reset page when color changes 
        setSelectedBuyer(value);
    };
    const handleSearchChange = (value) => {
        setCurrentPage(1); // Reset page when color changes
        setSelectedSearch(value);
    };

    const handleProNameChange = (value) => {
        setCurrentPage(1); // Reset page when color changes
        setSelectedPron(value);
    };
    const handleProDChange = (value) => {
        setCurrentPage(1); // Reset page when color changes
        setSelectedProd(value);
    };
    const handleMadeChange = (value) => {
        setCurrentPage(1); // Reset page when color changes
        setSelectedMade(value);
    };
    const handleSkuChange = (value) => {
        setCurrentPage(1); // Reset page when color changes
        setSelectedSku(value);
    };
    const [data123, setData123] = useState([]);
    const [meta123, setMeta123] = useState(1);
    const [isLoadingp, setIsLoadingp] = useState(false);
    useEffect(() => {
        if (productcode) {
            fetchData();
        }

    }, [productcode, selectedCategoryCode, selectedProductType, selectedColor, selectedFinish, selectedhsn, selectedBuyer, selectedSearch, selectedAlias, selectedpron, selectedpd, selectedmade, selectedsku, currentPage]);

    const fetchData = async () => {
        try {
            // Create a filter to exclude multiple product codes
            const product = productcode.map(id => `filters[ProductCode][$in][]=${id}`).join('&');
            // Fetch data with the filter
            let categoryFilter = '';
            if (selectedCategoryCode.length > 0) {
                const categoryFilterString = selectedCategoryCode.map(cat => `filters[CategoryCode][$eq]=${cat}`).join('&');
                categoryFilter = `&${categoryFilterString}`;
            }
            let protypeFilter = '';
            if (selectedProductType.length > 0) {
                const protypeFilterString = selectedProductType.map(pro => `filters[ProductTypeCode][$eq]=${pro}`).join('&');
                protypeFilter = `&${protypeFilterString}`;
            }
            let colorFilter = '';
            if (selectedColor.length > 0) {
                const colorFilterString = selectedColor.map(color => `filters[ColorCode][$eq]=${color}`).join('&');
                colorFilter = `&${colorFilterString}`;
            }
            let finishFilter = '';
            if (selectedFinish.length > 0) {
                const finishFilterString = selectedFinish.map(finish => `filters[FinishCode][$eq]=${finish}`).join('&');
                finishFilter = `&${finishFilterString}`;
            }
            let hsnFilter = '';
            if (selectedhsn.length > 0) {
                const hsnFilterString = selectedhsn.map(hsn => `filters[HSNCode][$eq]=${hsn}`).join('&');
                hsnFilter = `&${hsnFilterString}`;
            }
            let buyerFilter = '';
            if (selectedBuyer.length > 0) {
                const buyerFilterString = selectedBuyer.map(buyer => `filters[BuyerName][$eq]=${buyer}`).join('&');
                buyerFilter = `&${buyerFilterString}`;
            }
            let searchFilter = '';
            if (selectedSearch.length > 0) {
                const SearchFilterString = selectedSearch.map(search => `filters[SearchKeyword][$eq]=${search}`).join('&');
                searchFilter = `&${SearchFilterString}`;
            }
            let aliasFilter = '';
            if (selectedAlias.length > 0) {
                const aliasFilterString = selectedAlias.map(alias => `filters[ProductId][$eq]=${alias}`).join('&');
                aliasFilter = `&${aliasFilterString}`;
            }
            let pronFilter = '';
            if (selectedpron.length > 0) {
                const pronFilterString = selectedpron.map(pron => `filters[ProductName][$eq]=${pron}`).join('&');
                pronFilter = `&${pronFilterString}`;
            }
            let prodFilter = '';
            if (selectedpd.length > 0) {
                const prodFilterString = selectedpd.map(prod => `filters[ProductDesigner][$eq]=${prod}`).join('&');
                prodFilter = `&${prodFilterString}`;
            }
            let madeFilter = '';
            if (selectedmade.length > 0) {
                const madeFilterString = selectedmade.map(made => `filters[MadeBy][$eq]=${made}`).join('&');
                madeFilter = `&${madeFilterString}`;
            }
            let skuFilter = '';
            if (selectedsku.length > 0) {
                const skuFilterString = selectedsku.map(sku => `filters[BuyerSku][$eq]=${sku}`).join('&');
                skuFilter = `&${skuFilterString}`;
            }

            const apiUrl = `${ip}/api/products?populate=*&${product}&pagination[page]=${currentPage}${categoryFilter}${protypeFilter}${colorFilter}${finishFilter}${hsnFilter}${buyerFilter}${searchFilter}${aliasFilter}${pronFilter}${prodFilter}${madeFilter}${skuFilter}`;
            const response = await fetch(apiUrl);
            const json = await response.json();
            setData123(json.data);
            setMeta123(json.meta.pagination.pageCount);
            setIsLoadingp(false);
        } catch (error) {
            console.error('Error fetching product data:', error);
            setIsLoadingp(false);
        }
    };


    const [searchQuery, setSearchQuery] = useState('');
    const handleSearch = (value) => {
        setSearchQuery(value);
    }

    const [selectedRowIds, setSelectedRowIds] = useState([]);
    const handleCheckboxChange = (rowId, checked) => {
        if (checked) {
            setSelectedRowIds((prevSelectedRowIds) => [...prevSelectedRowIds, rowId]);
        } else {
            setSelectedRowIds((prevSelectedRowIds) =>
                prevSelectedRowIds.filter((selectedRowId) => selectedRowId !== rowId)
            );
        }
    };

    const handleCheckAll = (checked) => {
        if (checked) {
            // Select all items including previously selected ones
            setSelectedRowIds(data123.map((row) => row.id));
        } else if (selectedRowIds) {
            setSelectedRowIds((prevSelectedRowIds) =>
                [...prevSelectedRowIds, ...data123.map((row) => row.id)]);
        }
        else {
            // Deselect all items
            setSelectedRowIds([]);
        }
    };


    const [data1, setData1] = useState([])
    useEffect(() => {
        fetchDatac();
    }, []);
    const fetchDatac = async () => {
        const response = await fetch(`${ip}/api/company-details?populate=*`);
        const json = await response.json();
        setData1(json.data);
    };

    const [maindata, setMainData] = useState([])
    useEffect(() => {
        if (selectedRowIds) {
            fetchDataWithFilter(); // Fetch more data when currentPage changes
        }
    }, [selectedRowIds]);
    const fetchDataWithFilter = async () => {
        try {
            // Create a filter to exclude multiple product codes
            const excludeProductCodesFilter = selectedRowIds.map(code => `filters[id][$eq]=${code}`).join('&');
            // Fetch data with the filter
            const apiUrl = `${ip}/api/products?populate=*&pagination[page]=1&${excludeProductCodesFilter}`;
            const response = await fetch(apiUrl);
            const json = await response.json();
            const allData = [];
            for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
                const pageResponse = await fetch(`${ip}/api/products?populate=*&pagination[page]=${page}&${excludeProductCodesFilter}`);
                const pageJson = await pageResponse.json();
                allData.push(...pageJson.data);
            }
            const productData = allData.map(item => ({
                code: item.attributes.ProductId,
                name: item.attributes.ProductName,
                size: `${item.attributes.Length}x${item.attributes.Width}x${item.attributes.Height} ${item.attributes.SizeUnit}`,
                pcode: item.attributes.ProductCode,
            }));
            setMainData(productData);

        } catch (error) {
            console.error('Error fetching product data:', error);

        }
    };

    const handleDownloadPDF1 = (productData) => {
        const pdf = new jsPDF();
        const logoUrl = data1.length > 0 ? data1[0].attributes.Logo.data.attributes.url : '';
        const img = `${ip}${logoUrl}`;
        const boxWidth = 98;
        const boxHeight = 45;
        const boxesPerRow = 2;  // Number of boxes per row
        const maxBoxesPerPage = 12;
        // Iterate over each product in productData
        productData.forEach((product, index) => {
            if (index % maxBoxesPerPage === 0 && index !== 0) {
                // Add a new page if the maximum number of boxes per page is reached
                pdf.addPage();
            }
            const relativeIndex = index % maxBoxesPerPage;
            const row = Math.floor(relativeIndex / boxesPerRow);
            const col = relativeIndex % boxesPerRow;
            // Calculate the starting point of each box based on row and column
            const boxX = 5 + col * (boxWidth + 5);  // 5 is the horizontal margin between boxes
            const boxY = 3 + row * (boxHeight + 4);  // 5 is the vertical margin between boxes
            // Draw a box for each product
            pdf.rect(boxX, boxY, boxWidth, boxHeight);
            // Define the box properties for the logo within each box
            const logoWidth = 25; // Adjust the logo width as needed
            const logoHeight = 7; // Adjust the logo height as needed
            const logoX = 6 + boxX; // Adjust the X position as needed
            const logoY = 4 + boxY; // Adjust the Y position as needed
            // Add the logo to the PDF within each box
            pdf.addImage(img, 'JPEG', logoX, logoY, logoWidth, logoHeight);
            pdf.setFontSize(10);
            // Add product-specific information within each box
            pdf.text(`Code : ${product.code}`, 6 + boxX, 20 + boxY);
            pdf.text(`Name : ${product.name}`, 6 + boxX, 26 + boxY);
            const qrCode = QRCode(0, 'L');
            qrCode.addData(product.pcode);
            qrCode.make();
            const qrCodeImage = qrCode.createDataURL();
            const qrCodeWidth = 40;
            const qrCodeHeight = 40;
            pdf.addImage(qrCodeImage, 'JPEG', 55 + boxX, boxY + 2, qrCodeWidth, qrCodeHeight);

            pdf.text(`Size : ${product.size}`, 6 + boxX, 32 + boxY);
            pdf.text("Powered By :", 6 + boxX, 38 + boxY);
            pdf.setTextColor(46, 120, 204);
            // Add text with color and style within each box
            pdf.setFontSize(8);
            pdf.text("ERPDADDY Software Solution(p) Ltd.", 6 + boxX, 42 + boxY);
            pdf.setTextColor(0, 0, 0);
        });
        // Save the PDF as a file with the name 'example.pdf'
        pdf.save('QRPrint.pdf');
    };
    const handleDownloadPDF2 = (productData) => {
        const pdf = new jsPDF();
        const logoUrl = data1.length > 0 ? data1[0].attributes.Logo.data.attributes.url : '';
        const img = `${ip}${logoUrl}`;
        const boxWidth = 51;
        const boxHeight = 60;
        const boxesPerRow = 4;  // Number of boxes per row
        const maxBoxesPerPage = 20;
        // Iterate over each product in productData
        productData.forEach((product, index) => {
            if (index % maxBoxesPerPage === 0 && index !== 0) {
                // Add a new page if the maximum number of boxes per page is reached
                pdf.addPage();
            }
            const relativeIndex = index % maxBoxesPerPage;
            const row = Math.floor(relativeIndex / boxesPerRow);
            const col = relativeIndex % boxesPerRow;
            // Calculate the starting point of each box based on row and column
            const boxX = 1 + col * (boxWidth + 1);  // 5 is the horizontal margin between boxes
            const boxY = 1 + row * (boxHeight + 1);  // 5 is the vertical margin between boxes
            // Draw a box for each product
            pdf.rect(boxX, boxY, boxWidth, boxHeight);
            // Define the box properties for the logo within each box
            const logoWidth = 25; // Adjust the logo width as needed
            const logoHeight = 7; // Adjust the logo height as needed
            const logoX = 12.5 + boxX; // Adjust the X position as needed
            const logoY = 2 + boxY; // Adjust the Y position as needed
            // Add the logo to the PDF within each box
            pdf.addImage(img, 'JPEG', logoX, logoY, logoWidth, logoHeight);

            const qrCode = QRCode(0, 'L');
            qrCode.addData(product.pcode);
            qrCode.make();
            const qrCodeImage = qrCode.createDataURL();
            const qrCodeWidth = 40;
            const qrCodeHeight = 40;
            pdf.addImage(qrCodeImage, 'JPEG', 5.5 + boxX, boxY + 9, qrCodeWidth, qrCodeHeight);
            pdf.setFontSize(10);
            // Add product-specific information within each box
            pdf.text(`Code : ${product.code}`, 15.5 + boxX, 48 + boxY);
            pdf.text("Powered By", 15.5 + boxX, 53 + boxY);
            pdf.setTextColor(46, 120, 204);
            // Add text with color and style within each box
            pdf.setFontSize(8);
            pdf.text("ERPDADDY Software Solution(p) Ltd.", 2 + boxX, 58 + boxY);
            pdf.setTextColor(0, 0, 0);
        });
        // Save the PDF as a file with the name 'example.pdf'
        pdf.save('QRPrint.pdf');
    };
    const [isCartOpen, setIsCartOpen] = useState(false);
    const [openD, setOpenD] = useState(false);
    const handleCartClose = () => {
        setIsCartOpen(false);
    };
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <>
            <Container className='main'>
                <Stack className="table-toolbar" justifyContent="space-between">
                    <Stack direction='column' alignItems='flex-start'>
                        <Stack direction='column' alignItems='flex-start' >
                            <h3 className="title">QR Print</h3>
                            <Breadcrumb>
                                <Breadcrumb.Item>
                                    <Link to={`/${ugr}/dashboard`}>
                                        Home</Link></Breadcrumb.Item>
                                <Breadcrumb.Item active>Print</Breadcrumb.Item>
                            </Breadcrumb>
                        </Stack>
                        <Stack spacing={5} alignItems='flex-end'>
                            <Stack direction='column' alignItems='flex-start' >
                                <label>Current Fair Name</label>
                                <SelectPicker data={fairname} value={fairname.length > 0 ? fairname[0].label : ''} labelKey="label"
                                    valueKey="label" style={{ width: 150 }} />
                            </Stack>
                            <Stack direction='column' alignItems='flex-start' >
                                <label>Category</label>
                                <CheckPicker data={categorydata} value={selectedCategoryCode}
                                    onChange={handleCategoryChange} style={{ width: 200 }} />
                            </Stack>
                            <Stack direction='column' alignItems='flex-start' >
                                <label>Product Code</label>
                                <CheckPicker
                                    data={productypedata}
                                    placeholder="Product Type"
                                    value={selectedProductType}
                                    onChange={handleProductTypeChange}
                                    style={{ width: 150 }}
                                />
                            </Stack>


                            <Button appearance='default' active onClick={() => setOpenD(true)}>More Filter</Button>

                        </Stack>
                    </Stack>
                    <Stack direction='column' alignItems='flex-end' spacing={30} style={{ marginBottom: '-27px' }}>
                        <Stack direction='row' spacing={5}>
                            <InputGroup inside >
                                <Input placeholder="Search" value={searchQuery} onChange={(value) => handleSearch(value)} />
                                <InputGroup.Addon>
                                    <SearchIcon />
                                </InputGroup.Addon>
                            </InputGroup>

                        </Stack>

                    </Stack>
                </Stack>
                <Divider className='divide' />
                <div className="row">
                    <Panel>
                        <Table height={420} data={data123.filter(item => {
                            const ProductName = item.attributes.ProductName ? item.attributes.ProductName.toLowerCase() : '';
                            const AliasCode = item.attributes.ProductId ? item.attributes.ProductId.toLowerCase() : '';
                            const ColorName = item.attributes.ColorName ? item.attributes.ColorName.toLowerCase() : '';
                            const HSNCode = item.attributes.HSNCode ? item.attributes.HSNCode.toLowerCase() : '';
                            const CategoryName = item.attributes.CategoryName ? item.attributes.CategoryName.toLowerCase() : '';
                            const FinishName = item.attributes.FinishName ? item.attributes.FinishName.toLowerCase() : '';
                            const SearchKeyword = item.attributes.SearchKeyword ? item.attributes.SearchKeyword.toLowerCase() : '';
                            const MOQ = item.attributes.MOQ ? item.attributes.MOQ.toLowerCase() : '';
                            const ProductDesigner = item.attributes.ProductDesigner ? item.attributes.ProductDesigner.toLowerCase() : '';
                            const MadeBy = item.attributes.MadeBy ? item.attributes.MadeBy.toLowerCase() : '';
                            const ProductTypeName = item.attributes.ProductTypeName ? item.attributes.ProductTypeName.toLowerCase() : '';
                            // Master Search


                            return (
                                // Master Search
                                ProductName.includes(searchQuery.toLowerCase()) ||
                                AliasCode.includes(searchQuery.toLowerCase()) ||
                                ColorName.includes(searchQuery.toLowerCase()) ||
                                CategoryName.includes(searchQuery.toLowerCase()) ||
                                HSNCode.includes(searchQuery.toLowerCase()) ||
                                FinishName.includes(searchQuery.toLowerCase()) ||
                                SearchKeyword.includes(searchQuery.toLowerCase()) ||
                                MOQ.includes(searchQuery.toLowerCase()) ||
                                ProductDesigner.includes(searchQuery.toLowerCase()) ||
                                MadeBy.includes(searchQuery.toLowerCase()) ||
                                ProductTypeName.includes(searchQuery.toLowerCase())

                                // Master Search

                            );
                        })}
                            rowHeight={60}
                            rowKey="id"
                            bordered
                            cellBordered
                            loading={isLoadingp}
                        >
                            <Column width={60}>
                                <HeaderCell style={{ padding: 0 }}>
                                    <div style={{ lineHeight: '40px' }}>
                                        <Checkbox
                                            inline
                                            checked={selectedRowIds.length === data123.length}
                                            indeterminate={selectedRowIds.length > 0 && selectedRowIds.length < data123.length}
                                            onChange={handleCheckAll}
                                        />

                                    </div>
                                </HeaderCell>
                                <CheckCell
                                    dataKey="id"
                                    checkedKeys={selectedRowIds}
                                    onChange={(rowId, checked) => handleCheckboxChange(rowId, checked)}
                                    rowData={undefined}
                                />
                            </Column>
                            <Column width={80} align='center'>
                                <HeaderCell><b>Alias Code</b></HeaderCell>
                                <Cell dataKey={'attributes.ProductId'} />
                            </Column>

                            <Column width={160} align='center'>
                                <HeaderCell><b>Image</b></HeaderCell>
                                <Table.Cell>
                                    {(rowData) => {
                                        // Define a function to show the enlarged image on hover
                                        const renderTooltip = (imageSrc) => (
                                            <Tooltip style={{ backgroundColor: 'white' }}>
                                                <img
                                                    src={imageSrc}
                                                    alt="Product Image"
                                                    style={{ width: 400, height: 'auto' }}
                                                />
                                            </Tooltip>
                                        );

                                        return (
                                            <Whisper trigger="hover" placement="right" speaker={renderTooltip(`${ip}${rowData.attributes.CoverImage.data.attributes.url}`)}>
                                                <img
                                                    src={`${ip}${rowData.attributes.CoverImage.data.attributes.url}`}
                                                    alt="Product Image"
                                                    style={{ width: 50, height: 50, marginTop: '-16px' }}
                                                />
                                            </Whisper>
                                        );
                                    }}
                                </Table.Cell>
                            </Column>
                            <Column width={160} align='center'>
                                <HeaderCell><b>Product Name</b></HeaderCell>
                                <Cell dataKey={'attributes.ProductName'} />
                            </Column>
                            <Column width={160} align='center'>
                                <HeaderCell><b>Description</b></HeaderCell>
                                <Cell dataKey={'attributes.Description'} />
                            </Column>
                            <Column width={160} align='center'>
                                <HeaderCell><b>Dimension</b></HeaderCell>
                                <Cell>
                                    {(rowData) => {
                                        const { Length, Width, Height, SizeUnit } = rowData.attributes;
                                        const sizeInfo = `${Length} x ${Width} x ${Height} ${SizeUnit}`;
                                        return sizeInfo;
                                    }
                                    }
                                </Cell>
                            </Column>
                            <Column width={160} align='center'>
                                <HeaderCell><b>Finish</b></HeaderCell>
                                <Cell dataKey={'attributes.FinishName'} />
                            </Column>
                            <Column width={160} align='center'>
                                <HeaderCell><b>Color</b></HeaderCell>
                                <Cell dataKey={'attributes.ColorName'} />
                            </Column>
                            <Column width={180} align='center'>
                                <HeaderCell><b>CBM</b></HeaderCell>
                                <Cell dataKey={'attributes.cbm'} />
                            </Column>
                            <Column width={180} align='center'>
                                <HeaderCell><b>Nt. Wt.</b></HeaderCell>
                                <Cell dataKey={'attributes.NetWeight'} />
                            </Column>
                        </Table>
                        {meta123 > 1 && (
                            <Stack justifyContent='flex-end' style={{ marginTop: '10px' }}>
                                <Pagination total={meta123} limit={1} activePage={currentPage} onChangePage={setCurrentPage} />
                            </Stack>
                        )}
                        {selectedRowIds.length > 0 && (
                            <Notification type="success"
                                onClose={handleCartClose}
                                style={{
                                    position: 'fixed',
                                    top: '80%', right: 20,
                                    transform: 'translateY(-50%)',
                                    zIndex: 9999,
                                    background: '#0070a9',
                                    color: 'white',
                                    width: '20%',
                                }}>
                                <b style={{ color: 'white' }}>Selected Products : {selectedRowIds.length}</b>
                                <Divider vertical />
                                <IconButton icon={<QrcodeIcon />} onClick={handleOpen} style={{ float: 'right', marginTop: '-7px' }}><b>QR Print</b></IconButton>

                            </Notification>
                        )}
                    </Panel>
                </div>
                <Modal size='md' open={open} onClose={handleClose}>
                    <Modal.Header>
                        <Modal.Title>Print Formats</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <FlexboxGrid justify="space-around">
                            <FlexboxGrid.Item as={Col} colspan={24} md={12} style={{ marginBottom: '5px' }}>
                                <Button block style={{ height: '18vh' }} onClick={() => handleDownloadPDF1(maindata)}>
                                    <img src={s1} style={{ width: '74%' }} />
                                </Button>
                            </FlexboxGrid.Item>

                            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                                <Button block style={{ height: '18vh' }} onClick={() => handleDownloadPDF2(maindata)}>
                                    <img src={s2} style={{ width: '35%' }} />
                                </Button>
                            </FlexboxGrid.Item>
                            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                                <Button block style={{ height: '18vh' }}>
                                    <img src={s3} style={{ width: '43%' }} />
                                </Button>
                            </FlexboxGrid.Item>

                            <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                                <Button block style={{ height: '18vh' }}>
                                    <img src={s4} style={{ width: '29%' }} />
                                </Button>
                            </FlexboxGrid.Item>
                        </FlexboxGrid>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={handleClose} appearance="primary" color='cyan'>
                            Done
                        </Button>

                    </Modal.Footer>
                </Modal>
                <Drawer size="xs" open={openD} onClose={() => setOpenD(false)} backdrop='static'>
                    <Drawer.Header>
                        <Drawer.Title>Filter</Drawer.Title>
                        <Drawer.Actions>

                            <Button onClick={() => setOpenD(false)} appearance="primary" color='cyan'>
                                Confirm
                            </Button>
                        </Drawer.Actions>
                    </Drawer.Header>
                    <Drawer.Body>
                        <Stack direction='column' alignItems='center'>
                            <CheckPicker
                                data={aliasdata}
                                placeholder="Select Alias"
                                value={selectedAlias}
                                onChange={handleAliasChange}
                                style={{ width: 350, marginBottom: 20, marginTop: 20 }}
                            />
                            <CheckPicker value={selectedpron} onChange={handleProNameChange}
                                data={proNamedata} placement="autoVerticalStart" placeholder="Select Product" style={{ width: 350, marginBottom: 20 }} />
                            <CheckPicker value={selectedsku} onChange={handleSkuChange}
                                data={skudata} placement="autoVerticalStart" placeholder="Select SKU" style={{ width: 350, marginBottom: 20 }} />
                            <CheckPicker value={selectedBuyer} onChange={handleBuyerChange}
                                data={buyernamedata} placement="autoVerticalStart" placeholder="Select Buyer" style={{ width: 350, marginBottom: 20 }} />
                            <CheckPicker value={selectedFinish}
                                onChange={handleFinishChange} data={finishdata} placement="autoVerticalStart" placeholder="Select Finish" style={{ width: 350, marginBottom: 20 }} onOpen={fetchData4} />
                            <CheckPicker
                                data={colordata}
                                placeholder="Select Color"
                                placement="autoVerticalStart"
                                value={selectedColor}
                                onChange={handleColorChange}
                                style={{ width: 350, marginBottom: 20 }}
                                onOpen={fetchData5}
                            />
                            <CheckPicker value={selectedSearch} onChange={handleSearchChange}
                                data={searchdata} placement="autoVerticalStart" placeholder="Select Keyword" style={{ width: 350, marginBottom: 20 }} />
                            <CheckPicker value={selectedpd} onChange={handleProDChange}
                                data={proDdata} placement="autoVerticalStart" placeholder="Select Designer" style={{ width: 350, marginBottom: 20 }} />
                            <CheckPicker value={selectedmade} onChange={handleMadeChange}
                                data={madedata} placement="autoVerticalStart" placeholder="Select MadeBy" style={{ width: 350, marginBottom: 20 }} />
                            <CheckPicker value={selectedhsn}
                                onChange={handleHSNChange} data={hsndata} placement="autoVerticalStart" placeholder="Select HSN" style={{ width: 350, marginBottom: 20 }} onOpen={fetchData6} />

                        </Stack>
                    </Drawer.Body>
                </Drawer>
                <Stack className="copyright" justifyContent="flex-end" spacing={5} style={{ 'position': 'fixed', 'bottom': '0', 'width': '-webkit-fill-available', 'textAlign': 'center', 'backgroundColor': 'white', 'paddingRight': '16px' }}>
                    <p>© All Right Reserved. Product by </p><p> <a href="https://erpdaddy.com/" target="_blank">ERPDaddy Software Solution.</a></p>
                </Stack>
            </Container>
        </>
    )
}

export default QRPrint;